module.exports = __webpack_public_path__ + "media/images/athletes/1681-ce263a113d126fa27d9c9253e77a6114.png";